import { useCallback } from 'react';
import { Bar, BarChart, LabelList, Text as RechartsText, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { Text } from '@zillow/constellation-10';

import CompsToolTip from '../CompsToolTip';

const COMPS_DEFAULTS = {
  COMPS: 'Comps',
  YOUR_COMPS: 'Your comps',
};

const TwoBarChart = ({
  data: {
    needsDollarSign = false,
    domainMax = 42,
    chartType,
    adjustmentText,
    topBarAdjustment,
    bottomBarAdjustment,
    chartData,
    yAxisDataKey,
    topBarDataKey,
    bottomBarDataKey,
    tickColor = '#596B82',
    width = 90,
  },
}) => {
  const CustomYAxisTick = useCallback(({ y, payload: { value } }) => {
    if (chartType === COMPS_DEFAULTS.COMPS) {
      if (value === COMPS_DEFAULTS.YOUR_COMPS) {
        return (
          <g>
            <foreignObject x={0} y={51} width={100} height={100}>
              <CompsToolTip />
            </foreignObject>
          </g>
        );
      }
      return (
        <g>
          <foreignObject x={0} y={22} width={100} height={100}>
            <Text textStyle="body-sm" css={{ color: 'text.subtle' }}>
              {value}
            </Text>
          </foreignObject>
        </g>
      );
    }

    const adjustment = value === adjustmentText ? topBarAdjustment : bottomBarAdjustment;

    return (
      <g transform={adjustmentText && `translate(${0},${y + adjustment})`}>
        <RechartsText fontSize="14px" fill={tickColor} x={0} y={8} textAnchor="start">
          {value}
        </RechartsText>
      </g>
    );
  });

  return (
    <ResponsiveContainer debounce={200} width="99%" height={100}>
      <BarChart data={chartData} layout="vertical">
        <XAxis type="number" hide={true} style={{ textAnchor: 'middle' }} domain={[0, `dataMax + ${domainMax}`]} />
        <YAxis
          width={width}
          type="category"
          dataKey={yAxisDataKey}
          tickLine={false}
          minTickGap={1}
          tick={<CustomYAxisTick />}
        />
        <Bar isAnimationActive={false} dataKey={topBarDataKey} fill="#F2A619" barSize={16} minPointSize={1}>
          <LabelList
            fontWeight={700}
            dataKey={topBarDataKey}
            position="right"
            formatter={(value) => (needsDollarSign ? `$${value}` : value)}
          />
        </Bar>
        <Bar isAnimationActive={false} dataKey={bottomBarDataKey} fill="#0D4599" barSize={16} minPointSize={1}>
          <LabelList
            fontWeight={700}
            dataKey={bottomBarDataKey}
            position="right"
            formatter={(value) => (needsDollarSign ? `$${value}` : value)}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TwoBarChart;
